import { Box, Icon } from '@quintoandar-tokko/jopijs';
import RowName from '../../DashboardOverview/RowCards/components/RowName';
import ProgressBar from '../../DashboardOverview/RowCards/components/ProgressBar';
import ItemCount from '../../DashboardOverview/RowCards/components/ItemCount';
import PercentageValue from '../../DashboardOverview/RowCards/components/PercentageValue';
import WithoutCategoryTag from '../../DashboardOverview/RowCards/components/WithoutCategoryTag';
import { EVENT_QUALIFICATIONS } from '../../constants';
import styles from './doneVisits.module.scss';

const iconsMap = {
  [EVENT_QUALIFICATIONS.POSITIVE]: 'icon-positivo',
  [EVENT_QUALIFICATIONS.NEGATIVE]: 'icon-negativo',
  [EVENT_QUALIFICATIONS.NEUTRAL]: 'icon-neutro',
};

export default function DoneVisitsRow({
  name,
  percentage,
  count,
  qualification,
  useWithoutCategoryTag = false,
  ...rest
}) {
  const renderRowName = () => {
    if (useWithoutCategoryTag) return <WithoutCategoryTag text={name} />;

    if (qualification === null) {
      return <WithoutCategoryTag text={name} />;
    }

    if (!iconsMap[qualification]) {
      return <RowName text={name} />;
    }

    return (
      <Box className={styles.qualificationRowWrapper}>
        <Icon icon={iconsMap[qualification]} />
        <RowName text={name} />
      </Box>
    );
  };

  return (
    <Box className={styles.row} {...rest}>
      <Box className={styles.rowInnerWrapper}>
        {renderRowName()}
        <ProgressBar percentage={percentage} />
        <ItemCount icon={null} value={count} className={styles.itemCount} />
        <PercentageValue percentage={percentage} />
      </Box>
    </Box>
  );
}
